import { render } from "./helm.cattle.io.projecthelmchart.vue?vue&type=template&id=58489b60&scoped=true"
import script from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js"
export * from "./helm.cattle.io.projecthelmchart.vue?vue&type=script&lang=js"

import "./helm.cattle.io.projecthelmchart.vue?vue&type=style&index=0&id=58489b60&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58489b60"]])

export default __exports__